import { createSelector } from "@reduxjs/toolkit";
import { filter } from "lodash";

const EMPTY_ARRAY = [];

export const selectDocumentUploads = (state) => state?.documentUploads;

const selectDocumentUploadsState = (state, entityType) =>
  state?.documentUploads?.[entityType];

export const selectUploadedDocuments = createSelector(
  [selectDocumentUploadsState],
  (uploadsState) => uploadsState?.documents || EMPTY_ARRAY
);

export const selectDocTypes = createSelector(
  [selectDocumentUploadsState],
  (uploadsState) => uploadsState?.docTypes || EMPTY_ARRAY
);

export const selectRequirementDocuments = createSelector(
  [selectUploadedDocuments],
  (documents = []) => filter(documents, ["type", "REQUIREMENTS"])
);

export const selectUploadedDocumentsByEntityType = (entityType) =>
  createSelector(
    [selectDocumentUploads],
    (state) => state?.[entityType]?.documents || []
  );
